import { render, staticRenderFns } from "./Imi.vue?vue&type=template&id=5d4a2898&scoped=true&"
import script from "./Imi.vue?vue&type=script&lang=js&"
export * from "./Imi.vue?vue&type=script&lang=js&"
import style0 from "./Imi.vue?vue&type=style&index=0&id=5d4a2898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4a2898",
  null
  
)

export default component.exports